import { useState } from 'react';
import api from './MeshApi';

const PopulateHumanOpensearch = () => {
  const [isSaving, setIsSaving] = useState(false);
  const [saveErrorMessage, setSaveErrorMessage] = useState('');

  const handlePopulateHumanOpensearch = async () => {
    try {
      setIsSaving(true);
      setSaveErrorMessage('');
      await api.populateHumanOpensearch();
    } catch (error) {
      console.error('Failed to populate human opensearch:', error);
      setSaveErrorMessage('Failed to populate human opensearch. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="configuration-container">
      <div className="form-group">
        Confirm populate human opensearch
        <button
          className="btn submit-btn"
          onClick={handlePopulateHumanOpensearch}
          disabled={isSaving}
        >
          {isSaving ? 'Submitting...' : 'Submit'}
        </button>
        {saveErrorMessage && <div className="alert error-message">{saveErrorMessage}</div>}
      </div>
    </div>
  );
};

export default PopulateHumanOpensearch;
